/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ScrollStrategy, getMdScrollStrategyAlreadyAttachedError} from './scroll-strategy';
import {OverlayRef} from '../overlay-ref';
import {Subscription} from 'rxjs/Subscription';
import {ScrollDispatcher} from './scroll-dispatcher';
/**
 * Strategy that will close the overlay as soon as the user starts scrolling.
 */
export class CloseScrollStrategy implements ScrollStrategy {
private _scrollSubscription: Subscription|null = null;
private _overlayRef: OverlayRef;
/**
 * @param {?} _scrollDispatcher
 */
constructor(private _scrollDispatcher: ScrollDispatcher) { }
/**
 * @param {?} overlayRef
 * @return {?}
 */
attach(overlayRef: OverlayRef) {
    if (this._overlayRef) {
      throw getMdScrollStrategyAlreadyAttachedError();
    }

    this._overlayRef = overlayRef;
  }
/**
 * @return {?}
 */
enable() {
    if (!this._scrollSubscription) {
      this._scrollSubscription = this._scrollDispatcher.scrolled(null, () => {
        if (this._overlayRef.hasAttached()) {
          this._overlayRef.detach();
        }

        this.disable();
      });
    }
  }
/**
 * @return {?}
 */
disable() {
    if (this._scrollSubscription) {
      this._scrollSubscription.unsubscribe();
      this._scrollSubscription = null;
    }
  }
}

function CloseScrollStrategy_tsickle_Closure_declarations() {
/** @type {?} */
CloseScrollStrategy.prototype._scrollSubscription;
/** @type {?} */
CloseScrollStrategy.prototype._overlayRef;
/** @type {?} */
CloseScrollStrategy.prototype._scrollDispatcher;
}

